import { GetCompanyDataResult } from '../Interfaces/Interfaces';
import { ICompanyData, IPerms } from '../redux/constants';
import { ExternalRoutes } from '../Routes';
declare var window: any;
export const languagesOptions = [
    { label: 'English', value: 'en' },
    { label: '中文', value: 'cn' },
    { label: 'العربية', value: 'ar' },
    { label: 'Français', value: 'fr' }
];
export const DictlanguagesOptions: any = {
    'en': { label: 'English', value: 'en' },
    'cn': { label: '中文', value: 'cn' },
    'ar': { label: 'العربية', value: 'ar' },
    'fr': { label: "Français", value: "fr" }
};
export function GetPermissionDetailsByName(name: string, list: IPerms[]) {
    try {
        if (!list)
            return {
                Allowed: false,
                Perms: []
            };
        let _allpermsList: IPerms[] = [...list];
        let _parentList: any[] = [..._allpermsList].filter((item: IPerms) => (item && item.PermName) && (item.PermName.toLowerCase() === name.toLowerCase()));
        let _parentID = _parentList.length === 0 ? 0 : _parentList[0].PermID;
        let _allowed = _parentList.length === 0 ? false : ((_parentList[0].PermValID ? true : false) && (_parentList[0].PermValID !== 2) ? true : false);
        let _children = [...list].filter((item: IPerms) => item.ParentPermID === _parentID);
        return {
            Allowed: _allowed,
            Perms: _allowed ? [..._parentList, ..._children] : [] //as if deny no perm should be allowed 
        };
    } catch (e) {
        console.error(e);
        return {
            Allowed: false,
            Perms: []
        };
    }
}
var _isZendDeskDisplay = "";//locatsroge will stay after reload//not our practice
export function DisplayZendDeskChat(isVisble: boolean) {
    if (window && window.zE) {
        if (_isZendDeskDisplay !== `${isVisble}`) {
            window.zE('messenger:set', 'cookies', isVisble);
            _isZendDeskDisplay = `${isVisble}`;
        }
    }
}
export function CheckIfIsExternalPage(href: any): boolean {
    if (!href) return false;
    for (let route of ExternalRoutes) {
        if (href && href.toLowerCase().includes(route.path.toLowerCase())) {
            return true;
        }
    }
    return false;
}
export function isNumber(value: any) {
    return typeof value === 'number' && isFinite(value);
}
export function validateNumber(_number: any) {
    return _number !== undefined && _number !== null && isNumber(_number);
}
export function ValidateInput(value: string): boolean {//as !value can't check number
    return (value !== null && value !== undefined && value !== "");
}
export function validateEmail(email: any) {
    if (!email) return false;
    let regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
    return regex.test(email);
}
export function ValidateSelect(selected: any) {
    if (selected === null) return false;
    if (selected === undefined || selected.label === undefined || selected.value === undefined) return false;
    if (String(selected.value) === "-1") return false;
    return selected.value !== -1;
}
export function checkIfRevoultPaymentAllowed  ({ ConfigCompanyData, CompanyData }: { ConfigCompanyData: GetCompanyDataResult, CompanyData: ICompanyData }) {
    if (!ConfigCompanyData || !ConfigCompanyData.allowpayment || !CompanyData || !CompanyData.CompanyName) return false;
    return !!ConfigCompanyData.allowpayment.includes(CompanyData.CompanyName.toLowerCase());
}